import React from 'react';
import '../Style/VersionItem.css';
import {IPropsAccuracy} from '../Config/VersionItem.types';

const AccuracyTemplate = ({accuracy, id, onClick, featureName, featureVersionNumber, isCanOpenEvalImages, tags = [], label = '', attribute = ''}:IPropsAccuracy) => (
    <div className='accuracy-container-template'>
        <p onClick={() => isCanOpenEvalImages && onClick(id, accuracy, featureName, featureVersionNumber, tags, label, attribute)} className={`accuracy-p accuracy-p-active ${isCanOpenEvalImages && 'pointer'}`}>{`${accuracy}${accuracy !== 'N/A' ? '%' : ''}`}</p>
    </div>
);

export default AccuracyTemplate;
